// extracted by mini-css-extract-plugin
module.exports = {"root":"LoaderPage_root__N3Bpq","container":"LoaderPage_container__1Yi9L"};